import { format, isBefore, isValid, parseISO, startOfDay } from 'date-fns';
import { fr } from 'date-fns/locale';

const amountFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

/** Reads a number typed with a comma or a dot; `null` when it is not a number. */
export function parseQuoteNumber(value: string | number | undefined | null) {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const parsed = typeof value === 'number' ? value : Number(value.replace(/\s/g, '').replace(',', '.'));

  return Number.isFinite(parsed) ? parsed : null;
}

/** Amount of a numeric criterion in euros, or the raw value when it cannot be read as a number. */
export function formatQuoteAmount(value: string | number | undefined | null) {
  const amount = parseQuoteNumber(value);

  if (amount === null) {
    return value === undefined || value === null ? '' : String(value);
  }

  return amountFormatter.format(amount);
}

export function parseQuoteDate(value: string | null | undefined) {
  if (!value) {
    return null;
  }

  const date = parseISO(value);

  return isValid(date) ? date : null;
}

export function formatQuoteDate(value: string | null | undefined) {
  const date = parseQuoteDate(value);

  return date ? format(date, 'd MMMM yyyy', { locale: fr }) : null;
}

export function isQuoteExpired(expirationDate: string | null | undefined, today: Date = new Date()) {
  const date = parseQuoteDate(expirationDate);

  return date ? isBefore(date, startOfDay(today)) : false;
}

/** Stores a picked day as the start of that local day. */
export function toQuoteDate(date: Date | null) {
  return date && isValid(date) ? startOfDay(date).toISOString() : null;
}
